import { 
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    sendPasswordResetEmail,
    onAuthStateChanged,
    updateProfile
} from 'firebase/auth';

import { auth } from './firebase-config';

// Sign up function
export const signUp = async (email, password, displayName = null) => {
    try {
        console.log('Attempting to sign up user:', email);
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        
        // Update user profile with display name if provided
        if (displayName && displayName.trim()) {
            await updateProfile(userCredential.user, {
                displayName: displayName.trim()
            });
            console.log('User profile updated with display name:', displayName);
        }
        
        console.log('User signed up successfully');
        return { user: userCredential.user, error: null };
    } catch (error) {
        console.error('Sign up error:', error);
        let errorMessage = 'An error occurred during sign up.';
        
        switch (error.code) {
            case 'auth/email-already-in-use':
                errorMessage = 'This email is already registered. Please sign in instead.';
                break;
            case 'auth/invalid-email':
                errorMessage = 'Please enter a valid email address.';
                break;
            case 'auth/weak-password':
                errorMessage = 'Password should be at least 6 characters long.';
                break;
            default:
                errorMessage = error.message;
        }
        
        return { user: null, error: errorMessage };
    }
};

// Sign in function
export const signIn = async (email, password) => {
    try {
        console.log('Attempting to sign in user:', email);
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        console.log('User signed in successfully');
        return { user: userCredential.user, error: null };
    } catch (error) {
        console.error('Sign in error:', error);
        let errorMessage = 'An error occurred during sign in.';
        
        switch (error.code) {
            case 'auth/user-not-found':
            case 'auth/wrong-password':
            case 'auth/invalid-credential':
                errorMessage = 'Invalid email or password.';
                break;
            case 'auth/invalid-email':
                errorMessage = 'Please enter a valid email address.';
                break;
            case 'auth/user-disabled':
                errorMessage = 'This account has been disabled.';
                break;
            case 'auth/too-many-requests':
                errorMessage = 'Too many failed attempts. Please try again later.';
                break;
            default:
                errorMessage = error.message;
        }
        
        return { user: null, error: errorMessage };
    }
};

// Sign out function
export const signOutUser = async () => {
    try {
        console.log('Attempting to sign out user');
        await signOut(auth);
        console.log('User signed out successfully');
        return { error: null };
    } catch (error) {
        console.error('Sign out error:', error);
        return { error: 'Failed to sign out. Please try again.' };
    }
};

// Password reset function
export const resetPassword = async (email) => {
    try {
        console.log('Attempting to reset password for:', email);
        await sendPasswordResetEmail(auth, email);
        console.log('Password reset email sent successfully');
        return { error: null };
    } catch (error) {
        console.error('Password reset error:', error);
        let errorMessage = 'An error occurred while resetting password.';
        
        switch (error.code) {
            case 'auth/user-not-found':
                errorMessage = 'No account found with this email address.';
                break;
            case 'auth/invalid-email':
                errorMessage = 'Please enter a valid email address.';
                break;
            default:
                errorMessage = error.message;
        }
        
        return { error: errorMessage };
    }
};

// Auth state observer
export const onAuthStateChange = (callback) => {
    console.log('Setting up auth state observer');
    return onAuthStateChanged(auth, (user) => {
        console.log('Auth state changed:', user ? 'User logged in' : 'User logged out');
        callback(user);
    });
}; 